<div class="flex flex-col" [ngClass]="useRecipefirstStyle ? 'gap-[0.875rem]' : 'p-3 md:p-6 bg-white rounded-lg gap-2'">
  <div class="flex flex-row justify-between items-center" [ngClass]="useRecipefirstStyle ? 'gap-[0.5rem]' : 'flex-wrap'">
    <span [ngClass]="useRecipefirstStyle ? 'text-black text-[0.875rem]' : 'my-auto me-2 whitespace-nowrap'">{{'subscription.number_of_persons' |translate}}</span>
    <div class="flex flex-row rounded-full border border-e-dark-green" [ngClass]="useRecipefirstStyle ? 'w-[10.5rem] h-[1.75rem] flex-shrink-0' : 'w-1/2 min-w-[160px]'">
      @for (person_count of personChoices; track person_count; let i = $index) {
        <button
          (click)="setDefaultPersons(person_count)"
          class="transition-colors w-full duration-75 mx-1 rounded-full text-e-dark-green"
          [ngClass]="useRecipefirstStyle ? 
            {'bg-e-mid-green': pricingform.get('defaultpersons')?.value === person_count, 'ms-0': i===0, 'me-0': i=== personChoices.length-1, 'px-3': true, 'text-[0.75rem]': true, 'font-[600]': true} :
            {'bg-e-mid-green': pricingform.get('defaultpersons')?.value === person_count, 'ms-0': i===0, 'me-0': i=== personChoices.length-1, 'px-3': true, 'py-1': true}
          ">
          {{ person_count }}
        </button>
      }
    </div>
  </div>
  <div class="flex flex-row justify-between items-center" [ngClass]="useRecipefirstStyle ? 'gap-[0.5rem]' : 'flex-wrap'">
    <span [ngClass]="useRecipefirstStyle ? 'text-black text-[0.875rem] text-' : 'my-auto me-2 whitespace-nowrap'">{{'subscription.meals_per_week' |translate}}</span>
    <div class="flex flex-row rounded-full border border-e-dark-green" [ngClass]="useRecipefirstStyle ? 'w-[10.5rem] h-[1.75rem] flex-shrink-0' : 'w-1/2 min-w-[160px]'">
      @for (qty of recipeQuantities; track qty; let i = $index) {
        <button
          (click)="setDefaultRecipes(qty)"
          class="transition-colors w-full duration-75 mx-1 rounded-full text-e-dark-green"
          [ngClass]="useRecipefirstStyle ?
            {'bg-e-mid-green': pricingform.get('defaultrecipes')?.value === qty, 'ms-0': i===0, 'me-0': i=== recipeQuantities.length-1, 'px-3': true, 'text-[0.75rem]': true, 'font-[600]': true} :
            {'bg-e-mid-green': pricingform.get('defaultrecipes')?.value === qty, 'ms-0': i===0, 'me-0': i=== recipeQuantities.length-1, 'px-3': true, 'py-1': true}
          ">
          {{ qty }}
        </button>
      }
    </div>
  </div>
  @if (useRecipefirstStyle) {
  <div class="flex flex-row justify-between items-center gap-[0.5rem]">
    <span class="text-black text-[0.875rem]">{{'orderflow.info.lifestyle_preference' |translate}}</span>
    <div class="relative w-[10.5rem] flex-shrink-0" cdkOverlayOrigin #lifestyleTrigger="cdkOverlayOrigin">
      <div
        class="appearance-none w-full pl-[0.875rem] h-[1.75rem] pr-[0.625rem] rounded-full border border-e-dark-green text-black bg-white cursor-pointer flex items-center justify-between"
        (click)="toggleLifestyleOverlay()"
      >
        <span class="text-[0.875rem] capitalize">{{ _selectedLifestyle?.name || ('lifestyle.choose_lifestyle' | translate) }}</span>
        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 1.5L7.78623 7.75L14.0725 1.5" stroke="#3C4A34" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="lifestyleTrigger"
    [cdkConnectedOverlayOpen]="showLifestyleOverlay"
    [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="showLifestyleOverlay = false"
    [cdkConnectedOverlayBackdropClass]="'opacity-0'"
    [cdkConnectedOverlayPanelClass]="'rounded-lg'"
    [cdkConnectedOverlayOffsetY]="8"
  >
    @if (showLifestyleOverlay) {
      <div class="text-e-dark-green z-10 rounded-xl bg-white drop-shadow-md min-w-[160px] max-h-[300px] overflow-y-auto">
        @for (lifestyle of lifestyles; track lifestyle.id) {
          <div
            class="flex flex-row items-center justify-between rounded-lg px-3 py-2 hover:bg-e-dark-green hover:text-white cursor-pointer"
            [ngClass]="{
              'bg-e-dark-green text-white': _selectedLifestyle.id === lifestyle.id
            }"
            (click)="setLifestyle(lifestyle)"
          >
            <span class="text-sm font-light capitalize">{{ lifestyle.name }}</span>
          </div>
        }
      </div>
    }
  </ng-template>
  }
</div>
